/* CB Lighting - Day / Night switch in the header. Night is the default; the choice is remembered on this device. */
(function () {
  var KEY = 'cb-mode';
  function get() { try { return localStorage.getItem(KEY) || 'night'; } catch (e) { return 'night'; } }
  function set(m) {
    document.documentElement.setAttribute('data-cb-mode', m);
    try { localStorage.setItem(KEY, m); } catch (e) {}
    document.querySelectorAll('.cb-mode button').forEach(function (b) { b.setAttribute('aria-pressed', String(b.dataset.mode === m)); });
  }
  function mount() {
    if (document.querySelector('.cb-mode')) return;
    var icons = document.querySelector('.header__icons');
    if (!icons) return;
    var wrap = document.createElement('div');
    wrap.className = 'cb-mode';
    wrap.setAttribute('role', 'group');
    wrap.setAttribute('aria-label', 'Day or night mode');
    ['night', 'day'].forEach(function (m) {
      var b = document.createElement('button');
      b.type = 'button';
      b.dataset.mode = m;
      b.textContent = m === 'night' ? 'Night' : 'Day';
      b.addEventListener('click', function () { set(m); });
      wrap.appendChild(b);
    });
    icons.insertBefore(wrap, icons.firstChild);
    set(get());
  }
  set(get());
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount); else mount();
})();

/* ---------- mobile pass 2: fit headings + sticky add to cart ---------- */
(function () {
  function fit() {
    document.querySelectorAll('.cbx .disp, .product__title h1, .collection-hero__title').forEach(function (el) {
      if (el.closest('.cbx-sw__ghost')) return;
      el.style.removeProperty('font-size');
      var fs = parseFloat(getComputedStyle(el).fontSize), i = 0;
      function over() {
        if (!el.clientWidth) return false;
        var lim = Math.min(el.parentElement.getBoundingClientRect().right, document.documentElement.clientWidth);
        return el.scrollWidth > el.clientWidth + 1 || el.getBoundingClientRect().right > lim + 1;
      }
      while (over() && i < 40) {
        fs *= 0.96; el.style.setProperty('font-size', fs + 'px', 'important'); i++;
      }
    });
  }
  var t;
  window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(fit, 150); });
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit);
  window.addEventListener('load', fit);
  fit();

  var btn = document.querySelector('[id^="ProductSubmitButton-template"]');
  if (!btn || document.querySelector('.cb-sticky-atc')) return;
  var bar = document.createElement('div');
  bar.className = 'cb-sticky-atc';
  bar.innerHTML = '<div class="cb-sticky-atc__t"><span class="cb-sticky-atc__n"></span><span class="cb-sticky-atc__p"></span></div><button type="button">Add to cart</button>';
  var title = document.querySelector('.product__title h1');
  bar.querySelector('.cb-sticky-atc__n').textContent = title ? title.textContent.trim() : '';
  var b = bar.querySelector('button'), p = bar.querySelector('.cb-sticky-atc__p');
  document.body.appendChild(bar);
  document.body.classList.add('cb-has-sticky');
  function sync() {
    var cur = document.querySelector('[id^="ProductSubmitButton-template"]') || btn;
    btn = cur;
    var pr = document.querySelector('[id^="price-template"] .price'), s = null;
    if (pr) s = pr.classList.contains('price--on-sale') ? pr.querySelector('.price__sale .price-item--sale') : pr.querySelector('.price__regular .price-item--regular');
    var opts = [].map.call(document.querySelectorAll('variant-selects input:checked, variant-selects select'), function (i) { return i.value; }).join(' · ');
    p.textContent = [opts, s ? s.textContent.trim() : ''].filter(Boolean).join(' · ');
    var lbl = btn.querySelector('span');
    b.disabled = btn.disabled;
    b.textContent = btn.disabled && lbl ? lbl.textContent.trim() : 'Add to cart';
  }
  function poll() { [150, 500, 1100].forEach(function (d) { setTimeout(sync, d); }); }
  document.addEventListener('change', poll);
  sync();
  b.addEventListener('click', function () { if (!btn.disabled) btn.click(); });
  function onScroll() {
    var r = btn.getBoundingClientRect();
    bar.classList.toggle('is-on', r.bottom < 0);
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
})();

/* ---------- ring size bubble ---------- */
(function () {
  var wheel = '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><circle cx="12" cy="12" r="9"/><circle cx="12" cy="12" r="3"/><path d="M12 3v6M12 15v6M3 12h6M15 12h6"/></svg>';
  var fab = document.createElement('button');
  fab.type = 'button';
  fab.className = 'cb-fab';
  fab.setAttribute('aria-label', 'Find your wheel light size');
  fab.innerHTML = '<span class="cb-fab__i"><img src="https://cdn.shopify.com/s/files/1/0827/5912/3202/files/998F2D0B-2677-400E-8181-93A03AFBA9BB.webp?width=140" alt="" width="42" height="42"></span><span class="l">Find my wheel light size</span><span class="s">Wheel light size</span>';
  var fabImg = fab.querySelector('img');
  fabImg.onerror = function () { fabImg.parentNode.innerHTML = wheel; };
  var wrap = document.createElement('div');
  wrap.className = 'cb-fit';
  wrap.setAttribute('role', 'dialog');
  wrap.setAttribute('aria-modal', 'true');
  wrap.setAttribute('aria-label', 'Wheel light fitment finder');
  wrap.innerHTML = '<div class="cb-fit__bg"></div><div class="cb-fit__sheet"><div class="cb-fit__top"><span>Wheel light fitment</span><button type="button" class="cb-fit__x" aria-label="Close">&times;</button></div><div class="cb-fit__body"><p class="cb-fit__load">Loading the fitment guide…</p></div></div>';
  document.body.appendChild(fab);
  document.body.appendChild(wrap);
  var body = wrap.querySelector('.cb-fit__body'), loaded = false;

  function load() {
    if (loaded) return;
    loaded = true;
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(root + '?section_id=cb-fitment-finder').then(function (r) { return r.text(); }).then(function (html) {
      body.innerHTML = html;
      body.querySelectorAll('script').forEach(function (old) {
        var s = document.createElement('script');
        s.textContent = old.textContent;
        old.parentNode.replaceChild(s, old);
      });
    }).catch(function () {
      loaded = false;
      body.innerHTML = '<p class="cb-fit__load">Couldn’t load the guide. <a href="' + root + '#fitment">Open it here</a>.</p>';
    });
  }
  function open() {
    var onPage = document.getElementById('fitment');
    if (onPage && !wrap.contains(onPage)) { onPage.scrollIntoView({ behavior: 'smooth', block: 'start' }); return; }
    load();
    wrap.classList.add('is-open');
    document.body.classList.add('cb-fit-open');
    requestAnimationFrame(function () { requestAnimationFrame(function () { wrap.classList.add('is-in'); }); });
    wrap.querySelector('.cb-fit__x').focus();
  }
  function close() {
    wrap.classList.remove('is-in');
    document.body.classList.remove('cb-fit-open');
    setTimeout(function () { wrap.classList.remove('is-open'); fab.focus(); }, 280);
  }
  fab.addEventListener('click', open);
  wrap.querySelector('.cb-fit__bg').addEventListener('click', close);
  wrap.querySelector('.cb-fit__x').addEventListener('click', close);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && wrap.classList.contains('is-open')) close(); });

  function sticky() { document.body.classList.toggle('cb-sticky-on', !!document.querySelector('.cb-sticky-atc.is-on')); }
  window.addEventListener('scroll', sticky, { passive: true });
  sticky();
})();

/* ---------- video pause button ---------- */
(function () {
  var PAUSE = '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><rect x="6" y="5" width="4" height="14" rx="1"/><rect x="14" y="5" width="4" height="14" rx="1"/></svg>';
  var PLAY = '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M8 5.5v13l11-6.5z"/></svg>';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  document.querySelectorAll('.cbx video').forEach(function (v) {
    var box = v.parentElement;
    if (!box || box.querySelector('.cb-vidbtn')) return;
    if (getComputedStyle(box).position === 'static') box.style.position = 'relative';
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'cb-vidbtn';
    function sync() {
      var paused = v.paused;
      b.innerHTML = paused ? PLAY : PAUSE;
      b.setAttribute('aria-label', paused ? 'Play video' : 'Pause video');
    }
    b.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      if (v.paused) { v.play(); } else { v.pause(); }
    });
    v.addEventListener('play', sync);
    v.addEventListener('pause', sync);
    if (reduce) { v.removeAttribute('autoplay'); v.pause(); }
    box.appendChild(b);
    sync();
  });
})();

/* ---------- CB reviews: side tab + drawer, and photo fill on product pages (live Judge.me data) ---------- */
(function(){
  if(window.__cbRvTab)return;window.__cbRvTab=1;
  var SHOP=(window.Shopify&&window.Shopify.shop)||'cb-lighting.myshopify.com';
  var API='https://api.judge.me/reviews/reviews_for_widget';
  function q(pid){return API+'?url='+SHOP+'&shop_domain='+SHOP+'&platform=shopify&page=1&per_page=50&product_id='+pid;}
  function getJSON(u){return fetch(u).then(function(r){return r.ok?r.json():null;}).catch(function(){return null;});}
  function txt(html){var d=new DOMParser().parseFromString(html||'','text/html');return (d.body.textContent||'').trim();}
  function el(tag,cls,t){var e=document.createElement(tag);if(cls)e.className=cls;if(t!=null)e.textContent=t;return e;}
  function stars(n){var s=el('span','cbrt-stars');s.setAttribute('role','img');s.setAttribute('aria-label',n+' out of 5 stars');for(var i=1;i<=5;i++){var st=el('span',i<=n?'on':'off','★');st.setAttribute('aria-hidden','true');s.appendChild(st);}return s;}
  function fmt(d){var m=/(\d{4})-(\d{2})-(\d{2})/.exec(d||'');return m?m[2]+'/'+m[3]+'/'+m[1]:'';}

  /* photo lightbox */
  var lb,lbFrom;
  function openLb(src,alt,from){if(!lb){lb=el('div','cbrt-lb');lb.setAttribute('role','dialog');lb.setAttribute('aria-modal','true');lb.setAttribute('aria-label','Review photo');var im=el('img');var x=el('button','cbrt-lb__x','×');x.type='button';x.setAttribute('aria-label','Close photo');lb.appendChild(im);lb.appendChild(x);lb.addEventListener('click',function(e){if(e.target!==im)closeLb();});document.body.appendChild(lb);}
    var img=lb.querySelector('img');img.src=src;img.alt=alt||'Customer review photo';lbFrom=from;lb.classList.add('is-open');lb.querySelector('.cbrt-lb__x').focus();}
  function closeLb(){if(lb&&lb.classList.contains('is-open')){lb.classList.remove('is-open');if(lbFrom)lbFrom.focus();return true;}return false;}
  function pics(urls,name){var w=el('div','cbrt-pics');urls.forEach(function(p){var b=el('button','cbrt-pic');b.type='button';b.setAttribute('aria-label','Open photo from '+name);var i=el('img');i.loading='lazy';i.src=p.compact||p.small||p.original;i.alt='Review photo from '+name;b.appendChild(i);b.addEventListener('click',function(){openLb(p.huge||p.original,i.alt,b);});w.appendChild(b);});return w;}

  /* product pages: add photos the cached Judge.me widget is missing */
  function fillPhotos(){
    var w=document.querySelector('.jdgm-review-widget[data-product-id]');if(!w)return;
    var pid=w.getAttribute('data-product-id'),tries=0,map=null;
    function hasMedia(it){return it.querySelector('.cbrt-pics,video,img:not([src$=".svg"])');}
    function apply(){if(!map)return;w.querySelectorAll('.jm-review-item[review-uuid]').forEach(function(it){if(hasMedia(it))return;var r=map[it.getAttribute('review-uuid')];if(!r||!r.pictures_urls||!r.pictures_urls.length)return;(it.querySelector('.jm-review-content')||it).appendChild(pics(r.pictures_urls,r.reviewer_name||'customer'));});}
    (function wait(){
      if(!w.querySelector('.jm-review-item[review-uuid]')){if(tries++<60)setTimeout(wait,250);return;}
      getJSON(q(pid)).then(function(j){if(!j||!j.reviews)return;map={};j.reviews.forEach(function(r){map[r.uuid]=r;});apply();new MutationObserver(apply).observe(w,{childList:true,subtree:true});});
    })();
  }

  /* side tab + drawer with every published review */
  var tab,ov,dr,list,sum,loaded=false;
  function render(all){
    list.innerHTML='';sum.innerHTML='';
    if(!all.length){list.appendChild(el('p','cbrt-msg','No reviews yet.'));return;}
    var avg=all.reduce(function(s,r){return s+(+r.rating||0);},0)/all.length;
    sum.appendChild(el('span','cbrt-avg',avg.toFixed(1)));
    var m=el('div','cbrt-sum__meta');m.appendChild(stars(Math.round(avg)));m.appendChild(el('span','cbrt-count',all.length+(all.length===1?' review':' reviews')));sum.appendChild(m);
    all.forEach(function(r){
      var c=el('article','cbrt-card');c.appendChild(stars(+r.rating||0));
      var who=el('div','cbrt-who');who.appendChild(el('span','cbrt-name',r.reviewer_name||'Customer'));if(r.verified_buyer)who.appendChild(el('span','cbrt-ver','Verified buyer'));c.appendChild(who);
      var meta=el('div','cbrt-meta');meta.appendChild(el('span',null,fmt(r.created_at)));var a=el('a','cbrt-prod',r._title);a.href=r._url;meta.appendChild(a);c.appendChild(meta);
      if(r.title)c.appendChild(el('h3','cbrt-title',txt(r.title)));
      var b=txt(r.body_html);if(b)c.appendChild(el('p','cbrt-body',b));
      if(r.pictures_urls&&r.pictures_urls.length)c.appendChild(pics(r.pictures_urls,r.reviewer_name||'customer'));
      list.appendChild(c);
    });
  }
  function load(){
    if(loaded)return;loaded=true;
    getJSON('/products.json?limit=250').then(function(p){
      var prods=(p&&p.products)||[];
      return Promise.all(prods.map(function(pr){return getJSON(q(pr.id)).then(function(j){return {p:pr,j:j};});}));
    }).then(function(res){
      var all=[];res.forEach(function(x){if(x.j&&x.j.reviews)x.j.reviews.forEach(function(r){r._title=x.p.title;r._url='/products/'+x.p.handle;all.push(r);});});
      all.sort(function(a,b){return String(b.created_at||'').localeCompare(String(a.created_at||''));});
      render(all);
    }).catch(function(){loaded=false;list.innerHTML='';list.appendChild(el('p','cbrt-msg','Couldn’t load reviews. Try again in a moment.'));});
  }
  function open(){document.documentElement.classList.add('cbrt-lock');dr.removeAttribute('aria-hidden');tab.setAttribute('aria-expanded','true');load();setTimeout(function(){dr.querySelector('.cbrt-x').focus();},50);}
  function close(){document.documentElement.classList.remove('cbrt-lock');dr.setAttribute('aria-hidden','true');tab.setAttribute('aria-expanded','false');tab.focus();}
  function build(){
    tab=el('button','cbrt-tab');tab.type='button';tab.setAttribute('aria-haspopup','dialog');tab.setAttribute('aria-expanded','false');tab.setAttribute('aria-controls','cbrt-drawer');
    var s=el('span','cbrt-tab__star','★');s.setAttribute('aria-hidden','true');tab.appendChild(s);tab.appendChild(el('span',null,'Reviews'));
    ov=el('div','cbrt-ov');
    dr=el('aside','cbrt-dr');dr.id='cbrt-drawer';dr.setAttribute('role','dialog');dr.setAttribute('aria-modal','true');dr.setAttribute('aria-labelledby','cbrt-h');dr.setAttribute('aria-hidden','true');
    var head=el('div','cbrt-dr__head'),hw=el('div');hw.appendChild(el('p','cbrt-kick','// what owners say'));var h=el('h2','cbrt-h','Reviews');h.id='cbrt-h';hw.appendChild(h);head.appendChild(hw);
    var x=el('button','cbrt-x','×');x.type='button';x.setAttribute('aria-label','Close reviews');head.appendChild(x);
    sum=el('div','cbrt-sum');list=el('div','cbrt-list');list.appendChild(el('p','cbrt-msg','Loading reviews…'));
    dr.appendChild(head);dr.appendChild(sum);dr.appendChild(list);
    document.body.appendChild(tab);document.body.appendChild(ov);document.body.appendChild(dr);
    tab.addEventListener('click',open);x.addEventListener('click',close);ov.addEventListener('click',close);
    document.addEventListener('keydown',function(e){if(e.key!=='Escape')return;if(closeLb())return;if(document.documentElement.classList.contains('cbrt-lock'))close();});
    if(/[#&?]reviews\b/.test(location.hash+location.search))open();
  }
  function init(){build();fillPhotos();}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();

/* ---------- growth pack: owners photo gallery + cart free-shipping meter and add-ons ---------- */
(function(){
  if(window.__cbGrowth)return;window.__cbGrowth=1;
  var SHOP=(window.Shopify&&window.Shopify.shop)||'cb-lighting.myshopify.com';
  var FREE=65000; /* free shipping threshold in cents ($650) */
  var ADDONS=['magnetic-wire-holders','extensions','rock-light-magnets'];
  function el(tag,cls,t){var e=document.createElement(tag);if(cls)e.className=cls;if(t!=null)e.textContent=t;return e;}
  function getJSON(u,o){return fetch(u,o).then(function(r){return r.ok?r.json():null;}).catch(function(){return null;});}
  function money(c){var v=c/100;return '$'+(v%1?v.toFixed(2):v.toFixed(0));}

  /* owners gallery: review photos from Judge.me live data */
  function owners(){
    var sec=document.querySelector('[data-cb-owners]');if(!sec)return;
    var grid=sec.querySelector('[data-cb-owners-grid]');
    getJSON('/products.json?limit=250').then(function(p){
      var prods=(p&&p.products)||[];
      return Promise.all(prods.map(function(pr){return getJSON('https://api.judge.me/reviews/reviews_for_widget?url='+SHOP+'&shop_domain='+SHOP+'&platform=shopify&page=1&per_page=50&product_id='+pr.id).then(function(j){return {p:pr,j:j};});}));
    }).then(function(res){
      var items=[];
      (res||[]).forEach(function(x){if(x.j&&x.j.reviews)x.j.reviews.forEach(function(r){if(r.pictures_urls&&r.pictures_urls.length&&(+r.rating||0)>=4)items.push({r:r,p:x.p});});});
      items.sort(function(a,b){return String(b.r.created_at||'').localeCompare(String(a.r.created_at||''));});
      if(!items.length)return;
      grid.innerHTML='';
      items.slice(0,8).forEach(function(it){
        var r=it.r,pic=r.pictures_urls[0],name=r.reviewer_name||'Customer';
        var card=el('figure','cbown__card');
        var b=el('button','cbown__img');b.type='button';b.setAttribute('aria-label','Open photo from '+name);
        var img=el('img');img.loading='lazy';img.src=pic.huge||pic.original;img.alt=name+"'s "+it.p.title+' setup';b.appendChild(img);
        b.addEventListener('click',function(){lightbox(pic.huge||pic.original,img.alt,b);});
        var cap=el('figcaption','cbown__cap');
        var st=el('span','cbown__stars','★★★★★'.slice(0,Math.round(+r.rating||5)));st.setAttribute('aria-label',(+r.rating||5)+' out of 5 stars');
        cap.appendChild(st);cap.appendChild(el('span','cbown__name',name));
        var a=el('a','cbown__prod',it.p.title);a.href='/products/'+it.p.handle;cap.appendChild(a);
        card.appendChild(b);card.appendChild(cap);grid.appendChild(card);
      });
      sec.hidden=false;
    });
  }
  var lb,lbFrom;
  function lightbox(src,alt,from){
    if(!lb){lb=el('div','cbrt-lb');lb.setAttribute('role','dialog');lb.setAttribute('aria-modal','true');lb.setAttribute('aria-label','Customer photo');var im=el('img');var x=el('button','cbrt-lb__x','×');x.type='button';x.setAttribute('aria-label','Close photo');lb.appendChild(im);lb.appendChild(x);
      lb.addEventListener('click',function(e){if(e.target!==im)close();});document.addEventListener('keydown',function(e){if(e.key==='Escape')close();});document.body.appendChild(lb);}
    var i=lb.querySelector('img');i.src=src;i.alt=alt;lbFrom=from;lb.classList.add('is-open');lb.querySelector('.cbrt-lb__x').focus();
    function close(){if(lb.classList.contains('is-open')){lb.classList.remove('is-open');if(lbFrom)lbFrom.focus();}}
  }

  /* cart page: free shipping meter + add-ons */
  function shipMsg(total){
    if(total>=FREE)return ['You unlocked <strong>free shipping</strong>.',100];
    return ['You’re <strong>'+money(FREE-total)+'</strong> away from free shipping.',Math.max(4,Math.round(total*100/FREE))];
  }
  function cartPage(){
    var items=document.querySelector('cart-items');if(!items||!/^\/cart\/?$/.test(location.pathname))return;
    var meter=el('div','cbcart-ship');meter.setAttribute('role','status');
    meter.innerHTML='<p></p><div class="cbcart-ship__bar"><span style="width:0"></span></div>';
    items.parentNode.insertBefore(meter,items);
    var adds=el('div','cbcart-adds');adds.hidden=true;
    adds.innerHTML='<p class="cbcart__kick">// finish the install</p><h2 class="cbcart-adds__h">Add-ons people grab</h2><div class="cbcart-adds__list"></div>';
    items.parentNode.insertBefore(adds,items.nextSibling);
    var info={};
    Promise.all(ADDONS.map(function(h){return getJSON('/products/'+h+'.js').then(function(p){if(p)info[h]=p;});})).then(refresh);
    function refresh(){
      getJSON('/cart.js').then(function(c){
        if(!c)return;
        if(!c.item_count){meter.hidden=true;adds.hidden=true;return;}
        meter.hidden=false;
        var m=shipMsg(c.total_price);meter.querySelector('p').innerHTML=m[0];meter.querySelector('span').style.width=m[1]+'%';
        var inCart={},hasRock=false;
        c.items.forEach(function(i){inCart[i.handle]=1;if(/rock-light/.test(i.handle)&&!/magnet|mount/.test(i.handle))hasRock=true;});
        var list=adds.querySelector('.cbcart-adds__list');list.innerHTML='';
        ADDONS.forEach(function(h){
          var p=info[h];if(!p||!p.available||inCart[h])return;
          if(h==='rock-light-magnets'&&!hasRock)return;
          var v=p.variants[0];
          var row=el('div','cbcart-add');
          if(p.featured_image){var im=el('img');im.src=p.featured_image+(p.featured_image.indexOf('?')>-1?'&':'?')+'width=160';im.alt='';im.loading='lazy';row.appendChild(im);}
          var t=el('div','cbcart-add__t');var a=el('a',null,p.title);a.href=p.url||('/products/'+h);t.appendChild(a);t.appendChild(el('span',null,money(v.price)));row.appendChild(t);
          var b=el('button',null,'Add');b.type='button';b.setAttribute('aria-label','Add '+p.title+' to cart');
          b.addEventListener('click',function(){b.disabled=true;b.textContent='Adding…';
            getJSON('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:[{id:v.id,quantity:1}]})}).then(function(){location.reload();});});
          row.appendChild(b);list.appendChild(row);
        });
        adds.hidden=!list.children.length;
      });
    }
    var tmr;function later(){clearTimeout(tmr);tmr=setTimeout(refresh,400);}
    if(window.subscribe&&window.PUB_SUB_EVENTS&&window.PUB_SUB_EVENTS.cartUpdate){window.subscribe(window.PUB_SUB_EVENTS.cartUpdate,later);}
    new MutationObserver(later).observe(items,{childList:true,subtree:true});
  }

  /* add-to-cart popup: free shipping note */
  function cartNote(){
    var n=document.getElementById('cart-notification');if(!n)return;
    new MutationObserver(function(){
      if(!n.classList.contains('active'))return;
      getJSON('/cart.js').then(function(c){
        if(!c)return;
        var note=n.querySelector('.cbcart-note');
        if(!note){note=el('p','cbcart-note');var links=n.querySelector('.cart-notification__links');if(links)links.parentNode.insertBefore(note,links);else n.appendChild(note);}
        note.innerHTML=shipMsg(c.total_price)[0];
      });
    }).observe(n,{attributes:true,attributeFilter:['class']});
  }

  function init(){owners();cartPage();cartNote();}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();
